import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/index.vue'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        component: () => import('@/views/login/index.vue'),
    },
    {
        path: '/reg',
        component: () => import('@/views/reg/index.vue'),
    },
    {
        path: '/forget',
        component: () => import('@/views/forget/index.vue'),
    },
    {
        path: '/market',
        component: () => import('@/views/market/index.vue'),
    },
    {
        path: '/spot',
        component: () => import('@/views/spot/index.vue'),
    },
    {
        path: '/futures',
        component: () => import('@/views/futures/index.vue'),
    },
    {
        path: '/asset',
        component: () => import('@/views/asset/index.vue'),
    },
    {
        path: '/deposit',
        component: () => import('@/views/deposit/index.vue'),
    },
    {
        path: '/withdraw',
        component: () => import('@/views/withdraw/index.vue'),
    },
    {
        path: '/transfer',
        component: () => import('@/views/transfer/index.vue'),
    },
    {
        path: '/news',
        component: () => import('@/views/news/index.vue'),
    },
    {
        path: '/detail',
        component: () => import('@/views/news/detail.vue'),
    },
    {
        path: '/invite',
        component: () => import('@/views/invite/index.vue'),
    },
    {
        path: '/auth',
        component: () => import('@/views/auth/index.vue'),
    },
    {
        path: '/password',
        component: () => import('@/views/password/index.vue'),
    },
    {
        path: '/payword',
        component: () => import('@/views/payword/index.vue'),
    },
    {
        path: '/kefu',
        component: () => import('@/views/kefu/index.vue'),
    },
    {
        path: '/user',
        component: () => import('@/views/user/index.vue'),
    },
    {
        path: '/stock',
        component: () => import('@/views/stock/index.vue'),
    },
    {
        path: '/forex',
        component: () => import('@/views/forex/index.vue'),
    },
    {
        path: '/fund',
        component: () => import('@/views/fund/index.vue'),
    },
    {
        path: '/block',
        component: () => import('@/views/block/index.vue'),
    },
    {
        path: '/binfo',
        component: () => import('@/views/block/info.vue'),
    },
    {
        path: '/vote',
        component: () => import('@/views/vote/index.vue'),
    },
    {
        path: '/ipo',
        component: () => import('@/views/ipo/index.vue'),
    },
    {
        path: '/addr',
        component: () => import('@/views/addr/index.vue'),
    },
    {
        path: '/bank',
        component: () => import('@/views/bank/index.vue'),
    }

]

const router = new VueRouter({
    routes
})


// ======================================
// router.beforeEach((to, from, next) => {
//   // 1. 获取 token（看用户是否登录）
//   const token = localStorage.getItem('token')

//   // 2. 白名单：不需要登录就能访问的页面
//   const whiteList = [
//     '/',
//     '/home',
//     '/Finance',
//     '/Futures',
//     '/Markets',
//     '/Trade',
//     '/Trade/Spot',
//     '/login',
//     '/login/index',
//     '/login/register',
//     '/login/reset'
//   ]

//   // 如果在白名单 → 直接放行
//   if (whiteList.includes(to.path)) {
//     next()
//   }
//   // 不在白名单，且没有 token → 去登录
//   else if (!token) {
//     next('/login')
//   }
//   // 已登录 → 放行
//   else {
//     next()
//   }
// })


const originalPush = router.push
router.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
